// What a broadcaster is told about their own screen.
//
// Deliberately not the same words as the advertiser's campaign page, though it
// is the same derivation underneath. An advertiser cares whether their ad is
// on the glass; a broadcaster cares whether the box is earning, and why not.
// So "placeholder" reads as "Nothing booked" here -- for its owner that is a
// sales problem, not a fault.

export const SCREEN_STATE = {
    unreachable: {
        label: "Unreachable",
        tone: "danger",
        dot: "danger",
        note: "Not checking in. Nothing sold for now is running.",
    },
    stopped: {
        label: "Stopped",
        tone: "warn",
        dot: "warn",
        note: "You stopped this screen. It shows the placeholder until you resume.",
    },
    off_air: {
        label: "Off air",
        tone: "",
        dot: "idle",
        note: "Outside the hours you set, so the screen is dark.",
    },
    placeholder: {
        label: "Nothing booked",
        tone: "",
        dot: "idle",
        note: "Checking in with nothing sold for right now.",
    },
    playing: {
        label: "Playing",
        tone: "ok",
        dot: "ok",
        note: null,
    },
};

export function screenState(state) {
    return SCREEN_STATE[state] || { label: state || "Unknown", tone: "", dot: "idle", note: null };
}

// Same trap as the advertiser side: these timestamps are naive UTC, and
// new Date() would read them as local time.
export function utc(iso) {
    if (!iso) return null;
    const zoned = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(iso) ? iso : iso + "Z";
    const d = new Date(zoned);
    return isNaN(d.getTime()) ? null : d;
}

export function when(iso) {
    const d = utc(iso);
    return d ? d.toLocaleString(undefined, {
        month: "short", day: "numeric", hour: "numeric", minute: "2-digit",
    }) : "—";
}

export function sinceSeen(seconds) {
    if (seconds == null) return "never checked in";
    if (seconds < 90) return "just now";
    const minutes = Math.round(seconds / 60);
    if (minutes < 90) return `${minutes} min ago`;
    const hours = Math.round(minutes / 60);
    if (hours < 48) return `${hours} h ago`;
    return `${Math.round(hours / 24)} days ago`;
}
